import { type FC } from 'react';
import classnames from 'classnames';
import { graphql, useFragment } from 'react-relay';

import { FormattedMessage } from 'dibs-react-intl';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel.tsx';

import { getFaqs } from './tradeBenefitsFaqs.tsx';
import { TradeBenefitsFaqAccordionItem } from './TradeBenefitsFaqAccordionItem.tsx';
import { TradeBenefitsFaqSidebar } from './TradeBenefitsFaqSidebar.tsx';
import { TradeBenefitsFaqFooter } from './TradeBenefitsFaqFooter.tsx';

import { type TradeBenefitsFaq_viewer$key } from './__generated__/TradeBenefitsFaq_viewer.graphql.ts';

import styles from './TradeBenefitsFaq.scss';
import dibsCss from 'dibs-css';

const viewerFragment = graphql`
    fragment TradeBenefitsFaq_viewer on Viewer {
        ...TradeBenefitsFaqSidebar_viewer
    }
`;

const TradeBenefitsFaq: FC<{
    isTrade?: boolean;
    isFirmless?: boolean;
    viewer?: TradeBenefitsFaq_viewer$key;
}> = ({ isTrade = false, isFirmless = false, viewer: viewerRef }) => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const faqs = getFaqs();

    return (
        <HeadingLevel>
            {Heading => (
                <div
                    className={classnames(
                        styles.container,
                        dibsCss.grid,
                        dibsCss.itemsStart,
                        dibsCss.gapYLarge,
                        dibsCss.pbXlarge,
                        isTrade
                            ? [dibsCss.ptXlarge, dibsCss.gapXxlarge]
                            : [dibsCss.ptLarge, dibsCss.gapXMedium]
                    )}
                >
                    <div className={styles.faqColumn}>
                        <Heading
                            className={classnames(
                                styles.heading,
                                dibsCss.sassyFontHeaderXLarge,
                                dibsCss.mt0,
                                dibsCss.mbLarge
                            )}
                        >
                            <FormattedMessage
                                id="abt.TradeBenefitsFaq.title"
                                defaultMessage="Frequently Asked Questions"
                            />
                        </Heading>
                        <ul className={classnames(styles.list, dibsCss.p0, dibsCss.m0)}>
                            {faqs.map(({ id, question, answer }) => (
                                <TradeBenefitsFaqAccordionItem
                                    key={id}
                                    id={id}
                                    question={question}
                                    answer={answer}
                                />
                            ))}
                        </ul>
                    </div>
                    <TradeBenefitsFaqSidebar
                        isTrade={isTrade}
                        isFirmless={isFirmless}
                        viewer={viewer || null}
                    />
                    <TradeBenefitsFaqFooter />
                </div>
            )}
        </HeadingLevel>
    );
};

export { TradeBenefitsFaq };
